import { memo, Profiler, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button, Group } from '@mantine/core';
import { ChevronLeft } from 'lucide-react';
import { useHasPermission } from '../../../providers/AuthProvider';
import { useAdminUser } from '../../../hooks/useAdminUser';
import { UserInfoSection } from '../../../admin/components/UserInfoSection';
import { LazyDevicesTab } from '../../../admin/components/LazyComponents';

const AdminUserDevices = memo(() => {
  const hasManageDevices = useHasPermission('manage_devices') || true; // Temporaneamente abilitato per test
  const { id } = useParams<{ id: string }>();

  // Get admin user data and actions
  const adminUserData = useAdminUser();

  // TESTING PURPOSES ONLY
  const onRenderCallback = useCallback(
    (id: string, phase: string, actualDuration: number) => {
      if (actualDuration > 8) {
        // More aggressive threshold - half a frame
        console.warn(
          `🐌 Slow render detected in ${id}: ${phase} took ${actualDuration}ms`
        );
      }
    },
    []
  );

  if (!hasManageDevices) {
    return <div>Non hai i permessi per gestire i dispositivi</div>;
  }

  return (
    <Profiler id='AdminUserDevices' onRender={onRenderCallback}>
      <Group mb='md'>
        <Button
          variant='subtle'
          leftSection={<ChevronLeft size={16} />}
          component={Link}
          to={`/admin/users/${id}`}
        >
          Torna al Profilo Utente
        </Button>
      </Group>

      <UserInfoSection
        userInfo={adminUserData.userInfo}
        loadingUserInfo={adminUserData.loadingUserInfo}
      />

      <Profiler id='DevicesTab' onRender={onRenderCallback}>
        <LazyDevicesTab userId={adminUserData.userId} />
      </Profiler>
    </Profiler>
  );
});

AdminUserDevices.displayName = 'AdminUserDevices';

export default AdminUserDevices;
